import request from '@/utils/request'

/**
 * 获取作品分类列表（树形结构）
 */
export function getProductClassifyList() {
  return request.get('/app/product/classify/classifyList', {}, { token: false })
}
